import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Spinner from 'src/components/ui/Features/Spinner/Spinner';
import { PageHeader } from 'src/components/ui/GlobalComponents/PageHeader/PageHeader';
import { useLesson } from 'src/hook/data/useLesson';
import useUser from 'src/hook/data/useUser';
import { Ctx } from 'src/model/Scenario';
import { ScenariosLocation } from 'src/utils/URLUtils';
import styles from './ScenarioSubPage.module.scss';
import SubItem from './SubItem/SubItem';
const ScenarioSubPage = () => {
    const { scenarios, isLoading } = useLesson();
    const [currentContext, setCurrentContext] = useState<Ctx | null>(null);
    const [searchParams] = useSearchParams();
    const ref = searchParams.get('id');
    const { isDarkMode } = useUser();

    useEffect(() => {
        if (scenarios?.categories && ref) {
            const categoryRef = ref.substring(0, 2);
            const contextRef = ref.substring(2, 4);
            const category = scenarios.categories.find(cat => cat.ref === categoryRef);
            if (category) {
                const context = category.ctx.find(ctx => ctx.ref === contextRef);
                if (context) {
                    setCurrentContext(context);
                }
            }
        }
    }, [scenarios, ref]);

    if (isLoading || !scenarios) {
        return <Spinner />;
    }

    if (!ref || !currentContext) {
        return <div>Scenario not found</div>;
    }

    return (
        <div className={styles.scenarioSubPage}>
            <PageHeader
                backgroundColor={isDarkMode() ? '#333333' : '#D9DDED'}
                title={currentContext.name}
                backUrl="/scenario" forceUrl={true} />
            <div className={styles.questionImageContainer}>
                <div style={{ backgroundImage: `url(${ScenariosLocation(ref)})` }}
                    className={styles.questionImage} />
            </div>
            <div className={styles.grid}>
                {currentContext.chl.map((challenge, index) => (
                    <SubItem
                        key={index}
                        challenge={challenge}
                        scenarioRef={ref}
                    />
                ))}
            </div>
        </div>
    );
};

export default ScenarioSubPage;
